let Common = {};
Common.getTimeStamp = function(){
    let day = new Date();
    let yy = day.getFullYear();
	let mm = day.getMonth()+1<10 ? "0"+(day.getMonth()+1) : day.getMonth()+1;
    let dd = day.getDate()<10 ? "0"+day.getDate() : day.getDate();
	let hh = day.getHours()<10 ? '0' + day.getHours() : day.getHours();
	let mf = day.getMinutes()<10 ? '0'+ day.getMinutes() : day.getMinutes();
	let ss = day.getSeconds()<10 ? '0'+ day.getSeconds() : day.getSeconds();
	return yy +'-'+ mm +'-'+ dd +' '+ hh +':'+ mf +':'+ ss;
}
Common.getHistoryEndTime = function() {
	let day = new Date();
    let yy = day.getFullYear();
	let mm = day.getMonth()+1<10 ? "0"+(day.getMonth()+1) : day.getMonth()+1;
    let dd = day.getDate()<10 ? "0"+day.getDate() : day.getDate();
	return yy +'-'+ mm +'-'+ dd +' ' + '23:59:59';
}
Common.getHistoryStartTime = function() {
	let currentDay = new Date();
	let day = new Date(currentDay.getTime() - (6 * 24 * 60 * 60 * 1000));
    let yy = day.getFullYear();
	let mm = day.getMonth()+1<10 ? "0"+(day.getMonth()+1) : day.getMonth()+1;
    let dd = day.getDate()<10 ? "0"+ day.getDate() : day.getDate();
	return yy +'-'+ mm +'-'+ dd +' ' + '00:00:00';
}

Common.getHistoryStartTimeV3 = function() {
	let currentDay = new Date();
	let day = new Date(currentDay.getTime() - (29 * 24 * 60 * 60 * 1000));
    let yy = day.getFullYear();
	let mm = day.getMonth()+1<10 ? "0"+(day.getMonth()+1) : day.getMonth()+1;
    let dd = day.getDate()<10 ? "0"+ day.getDate() : day.getDate();
	return yy +'-'+ mm +'-'+ dd +' ' + '00:00:00';
}

Common.getHistoryCurrentStartTime = function() {
	let day = new Date();
    let yy = day.getFullYear();
	let mm = day.getMonth()+1<10 ? "0"+(day.getMonth()+1) : day.getMonth()+1;
    let dd = day.getDate()<10 ? "0"+day.getDate() : day.getDate();
	return yy +'-'+ mm +'-'+ dd +' ' + '00:00:00';
}
export default Common